import daylib from "dayjs";
import utc from "dayjs/plugin/utc";
import localizedFormat from "dayjs/plugin/localizedFormat";

daylib.extend(localizedFormat);
daylib.extend(utc);

export const dayjs = daylib;
